module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/989d99155bdb2720680a8c09fb7c454e.svg";